import { render } from "./EyerwebPatientExamTab.vue?vue&type=template&id=50e98a68&scoped=true"
import script from "./EyerwebPatientExamTab.vue?vue&type=script&lang=js"
export * from "./EyerwebPatientExamTab.vue?vue&type=script&lang=js"

import "./EyerwebPatientExamTab.vue?vue&type=style&index=0&id=50e98a68&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50e98a68"]])

export default __exports__